namespace TabAurous.OMS {
    @Serenity.Decorators.registerEditor()
    export class ReasonStatusEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            // add option accepts a key (id) value and display text value
            this.addOption("STATES", "States");
            this.addOption("REASON", "Reason");

        } 
    } 
}